import React from 'react';
import { Link } from 'react-router-dom';
import './TopBar.css';

const TopBar = ({ user }) => {
    if (!user) {
        return null;
    }

    return (
        <div className="top-bar">
            <div className="top-bar-user-actions">
                <div className="top-bar-icons">
                </div>
                <Link to="/profile" className="top-bar-user-info-link">
                    <div className="top-bar-user-info">
                        <p className="top-bar-user-name">{user.first_name} {user.last_name}</p>
                        <p className="top-bar-user-email">{user.email}</p>
                    </div>
                </Link>
            </div>
        </div>
    );
};

export default TopBar;
